/*
  botechToGraphData.js
*/

// Utils.
import getRandomId from './getRandomId';
import getUniqueLinkId from './getUniqueLinkId';

/**
 * Converts botech data to force-graph data.
 *
 * If using this function, maybe assume that it could throw an error if the
 * provided data is really bad.
 */
export default function botechToGraphData(botech) {

  const data = {
    
    // Botech meta fields.
    _botech: botech,

    // Main graphData fields.
    // NOTE: These get mutated by ForceGraph.
    nodes: [],
    links: [],

  };

  const nodeMap = {};

  if (botech?.nodes) {

    // Get the X and Y midpoints so that the camera starting at 0, 0
    // will be able to see the nodes.

    let midX = 0;
    let midY = 0;
    let midCount = 0;

    for (const node of botech.nodes) {
      if (node.id && typeof node.x === 'number' && typeof node.y === 'number') {
        midX += node.x;
        midY += node.y;
        midCount += 1;
      }
    }

    if (midCount > 0) {
      midX /= midCount;
      midY /= midCount;
    }

    for (const node of botech.nodes) {
      if (node.id) {

        const { id, x, y, ...rest } = node;
        const nodeObj = {
          id,
          x: typeof x === 'number' ? x - midX : undefined,
          y: typeof y === 'number' ? y - midY : undefined,
          _botech: rest
        };

        data.nodes.push(nodeObj);
        nodeMap[id] = nodeObj;

      }
    }
  }

  if (botech?.links) {
    for (const link of botech.links) {
      if (link.source && link.target) {

        const { id, source, target, ...rest } = link;

        // NOTE: Force-graph also accepts strings for source and target, in which case
        // it will mutate it after the initial render to be the corresponding node.
        // We would prefer this not to happen though.
        data.links.push({
          id: id || null,  // Optional. Generated further down if missing.
          source: nodeMap[source] || source,
          target: nodeMap[target] || target,
          _botech: rest
        });

      }
    }
  }

  // Add "_id" fields to each subroutine, purely to make them easier to deal
  // with in react code.

  if (botech?.subroutines?.length) {
    data._botech = { ...data._botech };
    data._botech.subroutines = data._botech.subroutines.map(obj => ({
      _id: getRandomId(),
      ...obj,
    }));
  }

  // Go through and make sure that missing IDs are filled in links.
  for (const link of data.links) {
    if (!link.id) {
      link.id = getUniqueLinkId(data);
    }
  }

  return data;

}
